import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function ArrowBracket(): React.ReactElement {
  return (
    <svg width="6" height="14" viewBox="0 0 6 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#arrowBracket)">
        <path d="M2 11L5 8L2 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="arrowBracket">
          <rect width="14" height="6" fill="white" transform="translate(0 14) rotate(-90)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
